module.exports = __webpack_public_path__ + "media/images/tienda-33e3668de62fed1d4b8659df7e4a14b2.jpg";